module.exports = __webpack_public_path__ + "img/dad-slider-detail.70d02ed9.jpg";